import { useMemo } from 'react';
import React from 'react';
import { getBrandConfig } from '../../config/brandConfig';
import useTailwindBrand from '../../Theme/useTailwindBrand';
import { ENV_DECLARONS, ENV_VERIFIED_TRAINER, getActiveClientBrandConfig, getActivePrestataireBrandConfig, getActivePrestationBrandConfig, isBrandActive } from '../../config/environment.config';
import { animationTeachr } from '../../Utils/Images';

export interface RegisterDesignConfig {
  globalCustom: string;
  firstCustom: string;
  textFirst: string;
  secondFirst: string;
  /** Espace client : titres de l'inscription adaptés au client */
  textFirstClient: string;
  secondFirstClient: string;
  // btnCustom: string;
  // customBtn: string;
  iconColor: string;
  rightContent: React.ReactNode | null;
  navGlobalCustom: string;
  // btnCustom1: string;
}

export function  useBrandAuthConfig() {
  const brandConfig = getBrandConfig();
  const { classes, common } = useTailwindBrand();
  const isVerifiedTrainer = brandConfig.name === 'verified-trainer';
  const isDeclarons = brandConfig.name === 'declarons';
  const isTeachr = brandConfig.name === 'teachr';

  const designConfig = useMemo<RegisterDesignConfig>(() => {
    if (isVerifiedTrainer) {
      return {
        globalCustom: `${classes.bgRegister} w-full`,
        firstCustom: '',
        textFirst: 'Devenir bien plus qu\'un coach sportif',
        secondFirst: '✔️ Votre compte a bien été créé. Merci de compléter votre profil afin de continuer.',
        textFirstClient: 'Atteignez vos objectifs avec un coach vérifié !',
        secondFirstClient: '✔️ Votre compte a bien été créé. Encore quelques informations et c\'est terminé !',
        // btnCustom: 'bg-white text-[#34454e] hover:bg-[#EAFAF9]',
        // customBtn:'',
        iconColor: classes.primaryText,
        navGlobalCustom: 'text-white',
        // btnCustom1: 'text-white',
        rightContent: (
          <div
            className={`flex flex-col items-center justify-center h-full text-white text-center px-10 ${classes.fontFamily}`}
          >
            <div className="mb-8">
              <img
                src="/brands/verified-trainer/images/sigle-logo-white.png"
                alt="Fitness Icon"
                className="w-24 h-24 mb-4 mx-auto"
              />
              <h3 className={`text-2xl font-bold mb-4 ${classes.fontFamily}`}>
                Depassez les limites du métier de coach sportif
              </h3>
              <p className={`text-lg opacity-90 ${classes.fontFamily}`}>
                Rejoignez un réseau qui vous appuie dans votre développement
              </p>
            </div>
            <div className={`space-y-4 text-left ${classes.fontFamily}`}>
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-[#FFB366] rounded-full"></div>
                <span>
                  Des avantages concrets (avance immédiate, partenariats...)
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-[#32CD32] rounded-full"></div>
                <span>
                  Des formations importantes (acquisition, fiscalité...)
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-[#0dcebf] rounded-full"></div>
                <span>
                  Un revenu passif pour plus de sécurité, de liberté et
                  d'ambition
                </span>
              </div>
            </div>
          </div>
        ),
      };
    } else if (isDeclarons) {
      return {
        globalCustom: 'bg-registerDec',
        firstCustom: '',
        textFirst: 'Simplifiez la gestion administrative de votre activité !',
        secondFirst: '✔️ Votre compte a bien été créé. Merci de compléter votre profil afin de continuer.',
        textFirstClient: 'Suivez vos prestations et vos documents en toute simplicité !',
        secondFirstClient: '✔️ Votre compte a bien été créé. Encore quelques informations et c\'est terminé !',
        // btnCustom: 'bg-white text-[#673AB7] hover:bg-[#F3E5F5]',
        // customBtn:'',
        iconColor: classes.primaryText,
        navGlobalCustom: 'text-white',
        // btnCustom1: 'text-white',
        rightContent: (
          <div
            className={`flex flex-col items-center justify-center h-full text-center px-8 ${classes.fontFamily} ${classes.primaryText}`}
          >
            <div className="mb-8">
              <img
                src="/brands/declarons/fiveicon.svg"
                alt="Déclarons Icon"
                className="w-24 h-24 mb-4 mx-auto"
              />
              <h3
                className={`${common.subtitle2} font-bold mb-4 ${classes.fontFamily}`}
              >
                Devenez prestataire
              </h3>
              <p
                className={`${classes.fontFamily} ${common.subtitle3} font-semibold`}
              >
                Concentrez-vous sur votre prestations nous réalisons toutes les
                démarches administratives à votre place, gratuitement.
              </p>
            </div>
          </div>
        ),
      };
    } else {
      // Teach'r - design par défaut
      return {
        // globalCustom: 'bg-registerSvg',
        globalCustom: 'bg-register',
        firstCustom: 'lg:bg-bgHomeRight',
        textFirst: 'Donner des cours particuliers, c\'est pas sorcier !',
        secondFirst: '✔️ Votre compte a bien été créé. Merci de compléter votre profil afin de continuer.',
        textFirstClient: 'Suivre ses cours particuliers, c\'est pas sorcier !',
        secondFirstClient: '✔️ Votre compte a bien été créé.\n Encore quelques informations et c\'est terminé !',
        // btnCustom: 'bg-white text-first',
        // customBtn:``,
        iconColor: classes.primaryText,
        navGlobalCustom: 'text-white',
        // btnCustom1: 'text-white',
        rightContent: null,
      };
    }
  }, [isVerifiedTrainer, isDeclarons, classes, common]);

  const getUserObject = useMemo(() => {
    const baseObject = {
      birthday: '',
      description: '',
      firebaseAuthToken: '',
      firebaseMessagingToken: '',
      firstName: '',
      lastName: '',
      mail: '',
      phone: '',
      sex: '',
      whereStudies: '',
      yearInStudies: 0,
      sponsorship: '',
    };

    if (isVerifiedTrainer) {
      return {
        ...baseObject,
        specializations: [],
        certifications: [],
        experienceYears: 0,
        sportsEquipment: [],
      };
    } else if (isDeclarons) {
      return {
        ...baseObject,
        businessType: '',
        siretNumber: '',
        address: '',
        administrativeServices: [],
      };
    } else {
      return baseObject;
    }
  }, [isVerifiedTrainer, isDeclarons]);

  const brandImages = {
    'teachr': {
      hero: '../Assets/Images/login_illustration.svg',
      background: '../Assets/Images/login_illustration.svg',
      icon: '/brands/teachr/icons/graduation-cap.svg',
      img: ""
    },
    'verified-trainer': {
      hero: '/brands/verified-trainer/images/fitness-login.jpg',
      background: '/brands/verified-trainer/images/sports-pattern.svg',
      icon: '/brands/verified-trainer/icons/dumbbell.svg',
      img: "/brands/verified-trainer/images/sigle-logo-white.png"
    },
    'declarons': {
      hero: '/brands/declarons/images/admin-login.jpg',
      background: '/brands/declarons/images/admin-pattern.svg',
      icon: '/brands/declarons/icons/document.svg',
      img: "/brands/declarons/fiveicon.svg"
    }
  };

  const brandContent = {
    'teachr': {
      title: "Connexion",
      subtitle: "Accédez à votre espace de cours particuliers",
      description: "Connectez-vous pour accéder à vos cours, votre planning et votre espace personnel",
      tagline: "L'éducation à portée de main",
      heroTitle:
        <div className='flex items-end gap-x-2 w-full'>
          <p className=''>Bienvenue sur </p> <img src={brandConfig.assets.logoWhite} alt="Chargement..." className={`l/oader /mx-auto w-1/4 `} /></div>,
      heroSubtitle: "Votre plateforme de cours particuliers"
    },
    'verified-trainer': {
      title: "Connexion",
      subtitle: "Accédez à votre espace",
      description: "Connectez-vous pour accéder à vos séances, votre planning et votre espace personnel",
      tagline: "Devenir plus qu'un coach sportif",
      heroTitle: "Bienvenue sur Verified Trainer",
      heroSubtitle: "Réseau de coachs sportifs vérifiés"
    },
    'declarons': {
      title: "Connexion",
      subtitle: "Accédez à votre espace",
      description: "Connectez-vous pour accéder à vos déclarations, documents et services",
      tagline: "Service à la personne simplifié",
      heroTitle: "Bienvenue sur Déclarons",
      heroSubtitle: "Votre plateforme de services à la personne"
    }
  };
  
  const arrayChoice = [
    {
      icon: '🙋‍♂️',
      title: `Je suis ${getActiveClientBrandConfig()}`,
      text: `Trouvez facilement le ${getActivePrestataireBrandConfig()} idéal pour vos besoins et réservez vos ${getActivePrestationBrandConfig()} en ligne`,
      statut : "client"
      // onClick: () => {
      //   handleClose();
      //   navigate(`/${getActiveBrandConfig()}/inscription/client`);
      // }
    },
    {
      icon: '🧑‍🏫',
      title: `Je suis ${getActivePrestataireBrandConfig()}`,
      text: `Partagez votre expertise et augmentez vos revenus en donnant des ${getActivePrestationBrandConfig("s")}.`,
      statut : "teachr"
      // onClick: () => {
      //   handleClose();
      //   navigate(`/${getActiveBrandConfig()}/register/`);
      // }
    },
  ];

  return {
    brandConfig,
    isVerifiedTrainer,
    isDeclarons,
    isTeachr,
    designConfig,
    getUserObject,
    classes,
    brandImages,
    brandContent,
    arrayChoice
  };
}

